import type { SocToken } from '@/styles/tokens'

/** The 3px leading faction stripe (--soc-stripe-width). */
export function FactionStripe({ token, className = '' }: { token: SocToken; className?: string }) {
  return (
    <span
      aria-hidden
      className={`absolute top-0 bottom-0 left-0 ${className}`}
      style={{ width: 'var(--soc-stripe-width)', background: `var(--soc-${token})` }}
    />
  )
}
